<template>
<v-flex mb-5 v-if="badURL">
    <course-not-found></course-not-found>
</v-flex>

<v-flex mb-5 v-else>
    <v-layout my-5>
        <v-flex xs12 xl8 offset-xl2>
            <v-layout align-center>
                <h1 class="text-xs-left display-2 my-2">Class Manager</h1>
                <v-spacer></v-spacer>
                <v-btn class="red white--text" @click="$router.go('-1')">Back</v-btn>
            </v-layout>
        </v-flex>
    </v-layout>

    <v-layout row wrap>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <course-edit-form :course="course"></course-edit-form>
        </v-flex>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <course-roster></course-roster>
        </v-flex>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <manual-override :course="course"></manual-override>
        </v-flex>
        <v-flex xs12 xl8 offset-xl2 my-5>
            <course-delete-form :course="course"></course-delete-form>
        </v-flex>
    </v-layout>
</v-flex>
</template>

<script>
import EditForm from './EditForm'
import DeleteForm from './DeleteForm'
import RosterDialog from './RosterDialog'
import ManualOverride from './ManualOverride'
import NotFound from '@/components/NotFound'

export default {
    components: {
        CourseEditForm: EditForm,
        CourseDeleteForm: DeleteForm,
        CourseRoster: RosterDialog,
        ManualOverride: ManualOverride,
        CourseNotFound: NotFound
    },
    computed: {
        course() {
            return this.$store.state.courseModule.courseInfo
        },
        badURL() {
            let slugs = this.$store.getters.semestersRouterFormat.map(s => s.slug)
            return (Object.keys(this.course).length === 0 && this.course.constructor === Object) || !slugs.includes(this.$route.params.semester_slug)
        }
    },
    created() {
        this.$store.dispatch('getTeachers')
        this.$store.dispatch('getStudents')
        this.$store.dispatch('getCourseManagerData', this.$route.params.course_id)
    }
}
</script>
